import { fromJS } from 'immutable'
import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return state
        .set('isFetching', true)
    case CHANGE_PASSWORD_SUCCESS:
      return state
        .set('authChangePassword', action.payload.user)
        .set('status', 200)
        .set('message', 'Change Password Successfully.')
        .set('isFetching', false)
    case CHANGE_PASSWORD_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('authChangePassword', action.payload.message)
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CHANGE_PASSWORD_RESET:
      return state
        .delete('authChangePassword')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth/auth-change-password-reducer.js